import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrincipalLayoutComponent } from '../../layout/principal-layout/principal-layout.component';
import { EstadisticasComponent } from './estadisticas.component';

const routes: Routes = [
  {
    path: 'estadisticas',
    component: PrincipalLayoutComponent,
    children: [
      { path: '', component: EstadisticasComponent },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EstadisticasRoutingModule { }
